import { render, staticRenderFns } from "./ExternalLinksBase.vue?vue&type=template&id=5527aab6&scoped=true"
import script from "./ExternalLinksBase.vue?vue&type=script&lang=js"
export * from "./ExternalLinksBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5527aab6",
  null
  
)

export default component.exports